import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bc61984"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "closefriend-hero background-white" }
const _hoisted_2 = { class: "container mt-3" }
const _hoisted_3 = {
  method: "POST",
  action: "/",
  class: "my-1"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-10 offset-xl-1" }
const _hoisted_6 = {
  class: "login-card bg-white p-4 mt-3",
  style: {"border-radius":"6px"}
}
const _hoisted_7 = { class: "login-body" }
const _hoisted_8 = { class: "form-group mt-1 mb-0" }
const _hoisted_9 = { class: "label float-right" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "form-group col-md-6" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Name", -1))
const _hoisted_14 = { class: "form-group col-md-6" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Email Address", -1))
const _hoisted_16 = { class: "form-group col-md-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Phone Number", -1))
const _hoisted_18 = { class: "form-group col-md-6" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Date of birth", -1))
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-12 col-12" }
const _hoisted_22 = {
  class: "form-group mb-0",
  style: {"position":"relative"}
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "icheck",
  class: "label ml-4 mt-0"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "I accept and agree to be bound by the terms and conditions contained in the following documents: ")
], -1))
const _hoisted_24 = { style: {"font-size":"13px"} }
const _hoisted_25 = { class: "errorMsg danger ml-2" }
const _hoisted_26 = { class: "row justify-content-center mx-md-0 mx-1 mb-1 mt-0" }
const _hoisted_27 = { class: "col-md-12 col-12 px-1" }
const _hoisted_28 = {
  class: "modal fade",
  id: "exampleModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_29 = { class: "modal-dialog" }
const _hoisted_30 = { class: "modal-content" }
const _hoisted_31 = { class: "modal-header" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, "Please fix this", -1))
const _hoisted_33 = { class: "modal-body" }
const _hoisted_34 = {
  key: 0,
  ref: "errorBlock",
  id: "errorBlock"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_toast = _resolveComponent("toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h5", null, [
                      _createTextVNode("E-Signature"),
                      _createElementVNode("label", _hoisted_9, "Date : " + _toDisplayString(_ctx.current_date), 1)
                    ]),
                    _hoisted_10
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _withDirectives(_createElementVNode("input", {
                        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeTagErr($event))),
                        onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                        autocomplete: "off",
                        type: "text",
                        placeholder: "Your Name",
                        class: "form-control selected-field",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.e_name) = $event)),
                        name: "e_name",
                        id: "e_name",
                        required: ""
                      }, null, 544), [
                        [_vModelText, _ctx.form.e_name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _withDirectives(_createElementVNode("input", {
                        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeTagErr($event))),
                        onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                        autocomplete: "off",
                        type: "text",
                        placeholder: "Your Email Address",
                        class: "form-control selected-field",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.e_email) = $event)),
                        name: "e_email",
                        id: "e_email",
                        required: ""
                      }, null, 544), [
                        [_vModelText, _ctx.form.e_email]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _withDirectives(_createElementVNode("input", {
                        onInput: _cache[4] || (_cache[4] = ($event: any) => {_ctx.checkPhone($event);}),
                        onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                        autocomplete: "off",
                        type: "text",
                        placeholder: "Your Phone Number",
                        class: "form-control selected-field",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.e_phone_no) = $event)),
                        name: "e_phone_no",
                        id: "e_phone_no",
                        required: ""
                      }, null, 544), [
                        [_vModelText, _ctx.form.e_phone_no]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _withDirectives(_createElementVNode("input", {
                        onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.removeTagErr($event))),
                        onfocus: "this.setAttribute('autocomplete','disable-autocomplete');",
                        autocomplete: "off",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.e_dob) = $event)),
                        type: "date",
                        placeholder: "Your Email Address",
                        class: "form-control selected-field",
                        name: "e_dob",
                        id: "e_dob",
                        required: ""
                      }, null, 544), [
                        [_vModelText, _ctx.form.e_dob]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("input", {
                          onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.confirmEvent($event))),
                          id: "icheck",
                          type: "checkbox",
                          class: "form-control",
                          name: "icheck",
                          required: ""
                        }, null, 32),
                        _hoisted_23,
                        _createElementVNode("ol", _hoisted_24, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docs, (doc) => {
                            return (_openBlock(), _createElementBlock("li", { key: doc }, _toDisplayString(doc), 1))
                          }), 128))
                        ]),
                        _createElementVNode("small", _hoisted_25, _toDisplayString(_ctx.confirm_error), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("button", {
                      id: "subBtn",
                      type: "button",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args))),
                      class: "btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                    }, " Submit Now ")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_toast, { ref: "toast" }, null, 512),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.closeModal('exampleModal'))),
              class: "btn btn-secondary",
              "data-mdb-dismiss": "modal"
            }, " Close ")
          ]),
          _createElementVNode("div", _hoisted_33, [
            (_ctx.errors.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: key,
                      class: "alert alert-danger"
                    }, _toDisplayString(error), 1))
                  }), 128))
                ], 512))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}